import { SERVER } from './../environment.constants';
export class FlightConfigurationURL {
    public static flightConfiguration: string = SERVER + "/configuration"
    public static userFlightConfiguration
         = (accountSeq: number) => `${FlightConfigurationURL.flightConfiguration}/${accountSeq}`
    public static addFlightConfiguration: string
         = FlightConfigurationURL.flightConfiguration + "/add";
}